import React from "react";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import MuiPagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";

import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import DoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

const Pagination = ({ show = false, handlePage, count = 0 }) => {
  return (
    <Box 
      py={2} 
      px={1} 
      m="auto" 
      display={show ? "flex" : "none"}
      width="min-content" 
      justifyContent="center"
      component={Paper} 
      elevation={1}
    >
      <MuiPagination
        size='small'
        count={count}
        onChange={handlePage}
        renderItem={(item) => (
          <PaginationItem
            slots={{ previous: ArrowUpIcon, next: ArrowDownIcon, first: DoubleArrowUpIcon, last: DoubleArrowDownIcon }}
            {...item}
          />
        )}
        showFirstButton
        showLastButton 
      />
    </Box>
  )
};


export default Pagination;